import React, { useEffect } from 'react'
import { useLocation, Switch, Route, Redirect } from 'react-router-dom'
import Box from '@material-ui/core/Box'
import SelectCoverage from 'scenes/provider/SelectCoverage'

// Lightweight router for the initial coverage selection step.
// No sidebar or navbar to keep focus on required coverage input.
const Main = (props) => {
    const location = useLocation()

    useEffect(() => {
        document.documentElement.scrollTop = 0
        document.scrollingElement.scrollTop = 0
    }, [location])

    return (
        <Box display='flex'>
            <Box position='relative' flex='1'>
                <Switch>
                    <Route 
                        path={'/select-coverage'}
                        render={(routeProps) => (
                            <SelectCoverage 
                                {...routeProps}
                                onCoverageSelected={props.onCoverageSelected}
                            />
                        )}
                    />
                    <Redirect from='*' to='/select-coverage' />
                </Switch>
            </Box>
        </Box>
    )
}

export default Main
